<div class="grid h-screen">
  <header style="min-height: 85px"></header>
  <main class="flex-grow">
  <div class="bg-[var(--surface-100)] min-h-screen">
    <router-outlet></router-outlet>
  </div>
</main>
  <footer style="min-height: 472px;"></footer>
</div>
